/* eslint-disable react-hooks/exhaustive-deps */
import { Progress, Form, BackTop, Spin } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import DataCorrelationService from '../../../services/DataCorrelation.service';
import DCDPOService from '../../../services/DCDPO.service';
import PolicyService from '../../../services/Policy.service';
import { useBlocker } from '../../../util/usePrompt';

import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step4 from './components/Step4';
import Step5 from './components/Step5';
import Step6 from './components/Step6';
import Step7 from './components/Step7';
import StepList from './components/StepList';
import StepPreview from './components/StepPreview';
import GlobalService from '../../../services/Global.service';

const { Provider } = Form;

const PrivacyDetail = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const notify = useNotify();

    const [state, updateState] = useState();
    const [applications, setApplications] = useState([]);

    const [currentSelectList, setCurrentSelectList] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loading_, setLoadingSave] = useState(false);
    const [loadingSaveDraft, setLoadingSaveDraft] = useState(false);
    const [fixed, setFixed] = useState(false);
    const [editMode, setEditMode] = useState(false);

    // form
    const [personalDataCollection] = Form.useForm();
    const [disclosurePersonalData] = Form.useForm();
    const [dataSubjectRightAndSecure] = Form.useForm();
    const [marketingAdvertising] = Form.useForm();
    const [privacyPolicy] = Form.useForm();
    const [dpo] = Form.useForm();
    const [dataController] = Form.useForm();

    const [previewData, setPreviewData] = useState();

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    const [dsType, setDsType] = useState([]);

    // check validations

    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [step6, setStep6] = useState(false);
    const [step7, setStep7] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(nextLocation.location.pathname);
    };

    const form = {
        personalDataCollection,
        disclosurePersonalData,
        dataSubjectRightAndSecure,
        marketingAdvertising,
        privacyPolicy,
        dpo,
        dataController,
    };

    useEffect(() => {
        const current = location.hash.replace('#step', '');
        if (current) {
            setCurrentSelectList(Number(current));
        }
        if (current === '8') {
            setFixed(false);
        }
    }, [location]);

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };

    // Sequence
    const [sequenceTemp, setSequenceTemp] = useState();
    const [personalDataOptionSequence, setPersonalDataOption_] = useState([]);
    const [
        sensitivePersonalDataOptionSequence,
        setSensitivePersonalDataOption_,
    ] = useState([]);

    const getPolicyNotice = async () => {
        try {
            setLoading(true);
            const { data } = await PolicyService.getPolicyNotice(id);
            if (data?.resultData) {
                const data_ = data?.resultData;
                const dataSourceFromCheck = [];
                if (data_.personalDataCollection.dataSourceFromDs) {
                    dataSourceFromCheck.push('dataSourceFromDs');
                }
                if (data_.personalDataCollection.dataSourceFromOther) {
                    dataSourceFromCheck.push('dataSourceFromOther');
                }
                const privacyPolicyNoticeDataSubjectType =
                    data_.personalDataCollection.privacyPolicyNoticeDataSubjectType.map(
                        (ds) => ds.dataSubjectId
                    );
                const personalDataCollection_ = {
                    ...data_.personalDataCollection,
                    effectiveDate: data_.personalDataCollection?.effectiveDate
                        ? moment(data_.personalDataCollection?.effectiveDate)
                        : null,
                    dataSourceFromCheck,
                    privacyPolicyNoticeDataSubjectType,
                };
                // const personalDataOptionSequence =
                //     data_?.disclosurePersonalData?.personalDataOptionSequence.map(
                //         (item) => item.personDataOptionId
                //     );

                setSequenceTemp({
                    personalDataOptionSequence:
                        data_?.disclosurePersonalData
                            ?.personalDataOptionSequence,
                    sensitivePersonalDataOptionSequence:
                        data_?.disclosurePersonalData
                            ?.sensitivePersonalDataOptionSequence,
                });
                let personalDataOption_ =
                    data_?.disclosurePersonalData?.personalDataOptionSequence?.map(
                        (item, index) => {
                            return {
                                ...item,
                                personDataOptionId: item.isAddOn
                                    ? moment().valueOf().toString() + index
                                    : item.personDataOptionId,
                            };
                        }
                    );
                let sensitivePersonalDataOption_ =
                    data_?.disclosurePersonalData?.sensitivePersonalDataOptionSequence?.map(
                        (item, index) => {
                            return {
                                ...item,
                                sensitivePersonDataOptionId: item.isAddOn
                                    ? moment().valueOf().toString() + index
                                    : item.sensitivePersonDataOptionId,
                            };
                        }
                    );

                setPersonalDataOption_(personalDataOption_);
                setSensitivePersonalDataOption_(sensitivePersonalDataOption_);

                const disclosurePersonalData_ = {
                    ...data_.disclosurePersonalData,
                    personalDataOptionAddOn:
                        data_?.disclosurePersonalData?.personalDataOptionAddOn?.map(
                            (item) => item.personalDataOptionAddOnTh
                        ),
                    sensitivePersonalDataOptionAddOn:
                        data_?.disclosurePersonalData?.sensitivePersonalDataOptionAddOn?.map(
                            (item) => item.sensitivePersonalDataOptionAddOnTh
                        ),
                    personalDataOptionSequence: personalDataOption_,
                    sensitivePersonalDataOptionSequence:
                        sensitivePersonalDataOption_,
                };

                personalDataCollection.setFieldsValue(personalDataCollection_);
                disclosurePersonalData.setFieldsValue(disclosurePersonalData_);
                dataSubjectRightAndSecure.setFieldsValue(
                    data_.dataSubjectRightAndSecure
                );
                marketingAdvertising.setFieldsValue(data_.marketingAdvertising);
                privacyPolicy.setFieldsValue(data_.privacyPolicy);
                dpo.setFieldsValue(data_.dpo);
                dataController.setFieldsValue(data_.dataController);
                setPreviewData(data_);
                setLoading(false);
                setEditMode(true);
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id !== 'new') getPolicyNotice();
        else getDCDPO();
        getApplications();
        getDsTypeDropdown();
    }, [id]);

    const onFormChange = (name, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const genaratePayload = (name, isPublish) => {
        let payload = {};
        let privacyPolicyNoticeDataSubjectType = [];

        const dsTypeGroup =
            personalDataCollection.getFieldsValue()
                .privacyPolicyNoticeDataSubjectType;

        if (dsTypeGroup) {
            const dsTypefilter = dsType.filter((ds) =>
                dsTypeGroup.includes(ds.id)
            );
            privacyPolicyNoticeDataSubjectType = dsTypefilter.map((ds) => {
                return {
                    dataSubjectId: ds.id,
                    dataSubjectNameTh: ds.nameTh,
                    dataSubjectNameEn: ds.nameEn,
                };
            });
        }

        const personalDataCollection_ = {
            ...personalDataCollection.getFieldsValue(),
            dataSourceFromDs: personalDataCollection
                .getFieldsValue()
                .dataSourceFromCheck?.includes('dataSourceFromDs'),
            dataSourceFromOther: personalDataCollection
                .getFieldsValue()
                .dataSourceFromCheck?.includes('dataSourceFromOther'),
            effectiveDate: personalDataCollection.getFieldsValue()
                ?.effectiveDate
                ? moment(
                      personalDataCollection.getFieldsValue()?.effectiveDate
                  ).format('YYYY-MM-DDT00:00:00.000+00:00')
                : null,
            privacyPolicyNoticeDataSubjectType,
        };

        const disclosurePersonalData_ = {
            ...disclosurePersonalData.getFieldsValue(),
            personalDataOptionAddOn: [],
            sensitivePersonalDataOptionAddOn: [],
            personalDataOptionSequence: disclosurePersonalData
                .getFieldsValue()
                .personalDataOptionSequence?.map((item, i) => {
                    return {
                        ...item,
                        personDataOptionId: item.isAddOn
                            ? ''
                            : item.personDataOptionId,
                        sequence: i + 1,
                    };
                }),
            sensitivePersonalDataOptionSequence: disclosurePersonalData
                .getFieldsValue()
                .sensitivePersonalDataOptionSequence?.map((item, i) => {
                    return {
                        ...item,
                        sensitivePersonDataOptionId: item.isAddOn
                            ? ''
                            : item.sensitivePersonDataOptionId,
                        sequence: i + 1,
                    };
                }),
        };

        if (id === 'new') {
            payload = {
                isPublish,
                personalDataCollection: personalDataCollection_,
                disclosurePersonalData: disclosurePersonalData_,
                dataSubjectRightAndSecure:
                    dataSubjectRightAndSecure.getFieldsValue(),
                marketingAdvertising: marketingAdvertising.getFieldsValue(),
                privacyPolicy: privacyPolicy.getFieldsValue(),
                dpo: dpo.getFieldsValue(),
                dataController: dataController.getFieldsValue(),
            };
        } else {
            payload = {
                isPublish,
                privacyNoticeId: id,
                personalDataCollection: personalDataCollection_,
                disclosurePersonalData: disclosurePersonalData_,
                dataSubjectRightAndSecure:
                    dataSubjectRightAndSecure.getFieldsValue(),
                marketingAdvertising: marketingAdvertising.getFieldsValue(),
                privacyPolicy: privacyPolicy.getFieldsValue(),
                dpo: dpo.getFieldsValue(),
                dataController: dataController.getFieldsValue(),
            };
        }

        if (!isPublish) setLoadingSaveDraft(true);
        else setLoadingSave(true);

        setOpenChange(false);
        setChange(false);

        PolicyService.updatePolicyNotice(payload)
            .then(({ data }) => {
                if (data.resultCode === 1) {
                    setLoadingSave(false);
                    setLoadingSaveDraft(false);
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully saved data'),
                    });
                    setFixed(false);
                    // getPolicyNotice(data?.resultData?.privacyNoticeId);
                    if (name === 'preview') {
                        navigate(ROUTER.POLICY.DEFAULT);
                    }
                    if (!isPublish) {
                        const privacyNoticeId =
                            data?.resultData?.privacyPolicyNoticeId;
                        const hash = window.location.hash;
                        navigate(
                            ROUTER?.POLICY?.PRIVACY_NOTICES +
                                `/${privacyNoticeId}${hash}`
                        );
                        getPolicyNotice();
                    }
                } else {
                    setLoadingSave(false);
                    setLoadingSaveDraft(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                setLoadingSave(false);
                setLoadingSaveDraft(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            });
    };

    const saveDraft = () => {
        genaratePayload(null, false);
    };

    const onFormFinish = (name, _) => {
        genaratePayload(name, true);
    };

    const getApplications = async () => {
        try {
            const { data } = await DataCorrelationService.getApplications();
            if (data) {
                setApplications(data.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getDCDPO = async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            if (item) {
                if (item?.staffNameDPOTh) {
                    setStep6(true);
                }
                if (item?.nameDPOTh) {
                    setStep7(true);
                }
                dpo.setFieldsValue({
                    dpoNameTh: item?.staffNameDPOTh,
                    dpoNameEn: item?.staffNameDPOEn,
                });
                dataController.setFieldsValue({
                    contactChannelTh: `${item?.nameDPOTh}\n${item?.addressTh}`,
                    contactChannelEn: `${item?.nameDPOEn}\n${item?.addressEn}`,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                setDsType(data?.resultData?.dataSubjectType);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const steps = [step1, step2, step3, step4, step5, step6, step7];
    const passStep = steps.every((step) => step === true);
    const filter = steps.filter(Boolean).length;
    const currentProgress = ((filter * 100) / steps.length).toFixed(0);
    const stepObject = steps.reduce((result, step, index) => {
        const stepName = `step${index + 1}`;
        return { ...result, [stepName]: step };
    }, {});

    return (
        <>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(ROUTER.POLICY.DEFAULT);
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add Privacy Notice')
                            : t('Edit Privacy Notice')}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Policy')} / {t('Privacy Policy')} /{' '}
                </span>
                <span>
                    {id === 'new'
                        ? t('Add Privacy Notice')
                        : t('Edit Privacy Notice')}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {currentSelectList !== 8 && (
                    <StepList
                        steps={stepObject}
                        setCurrentSelectList={() => {
                            // cannot move sp5
                        }}
                        SW={state?.SW}
                        currentSelectList={currentSelectList}
                        setFixed={setFixed}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': currentSelectList !== 8,
                        'col-span-4': currentSelectList === 8,
                    })}
                >
                    {currentSelectList !== 8 && (
                        <div className="bg-white rounded-md p-4 flex font-semibold text-base">
                            <div className="flex-1 -mt-0.5">
                                <Progress
                                    strokeColor={{
                                        '0%': '#4ACE8F',
                                        '100%': '#4ACE8F',
                                    }}
                                    percent={currentProgress}
                                    status="active"
                                    showInfo={false}
                                />
                            </div>
                            <span
                                className={`pl-6 pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}% {t('succeed')}
                            </span>

                            <span>{t('filledinformation')}</span>
                        </div>
                    )}
                    <Spin spinning={loading}>
                        <Provider
                            onFormChange={onFormChange}
                            onFormFinish={onFormFinish}
                        >
                            <div className="mt-4 bg-white rounded-md p-6 overflow-hidden">
                                <StepWizard
                                    isHashEnabled
                                    instance={setInstance}
                                    onStepChange={(e) => {
                                        setCurrentSelectList(e.activeStep);
                                    }}
                                >
                                    <Step1
                                        setStep1={setStep1}
                                        dsType={dsType}
                                        loading={loading_}
                                        editMode={editMode}
                                        applications={applications}
                                        setApplications={setApplications}
                                        form={personalDataCollection}
                                        saveDraft={saveDraft}
                                        previewData={previewData}
                                    />
                                    <Step2
                                        setStep2={setStep2}
                                        sequenceTemp={sequenceTemp}
                                        personalDataOptionSequence={
                                            personalDataOptionSequence
                                        }
                                        setPersonalDataOption_={
                                            setPersonalDataOption_
                                        }
                                        sensitivePersonalDataOptionSequence={
                                            sensitivePersonalDataOptionSequence
                                        }
                                        setSensitivePersonalDataOption_={
                                            setSensitivePersonalDataOption_
                                        }
                                        loading={loading_}
                                        editMode={editMode}
                                        form={disclosurePersonalData}
                                        saveDraft={saveDraft}
                                        previewData={previewData}
                                    />
                                    <Step3
                                        setStep3={setStep3}
                                        loading={loading_}
                                        editMode={editMode}
                                        form={dataSubjectRightAndSecure}
                                        saveDraft={saveDraft}
                                        previewData={previewData}
                                    />
                                    <Step4
                                        setStep4={setStep4}
                                        loading={loading_}
                                        editMode={editMode}
                                        form={marketingAdvertising}
                                        saveDraft={saveDraft}
                                        previewData={previewData}
                                    />
                                    <Step5
                                        setStep5={setStep5}
                                        loading={loading_}
                                        editMode={editMode}
                                        form={privacyPolicy}
                                        saveDraft={saveDraft}
                                        previewData={previewData}
                                    />
                                    <Step6
                                        setStep6={setStep6}
                                        loading={loading_}
                                        editMode={editMode}
                                        form={dpo}
                                        saveDraft={saveDraft}
                                        previewData={previewData}
                                    />
                                    <Step7
                                        setStep7={setStep7}
                                        passStep={passStep}
                                        loading={loading_}
                                        editMode={editMode}
                                        form={dataController}
                                        AllForm={form}
                                        saveDraft={saveDraft}
                                        previewData={previewData}
                                    />
                                    <StepPreview
                                        loading_={loading_}
                                        loadingSaveDraft={loadingSaveDraft}
                                        loading={loading}
                                        applications={applications}
                                        data={{
                                            ...previewData,
                                            personalDataCollection:
                                                personalDataCollection.getFieldsValue(),
                                            disclosurePersonalData:
                                                disclosurePersonalData.getFieldsValue(),
                                            dataSubjectRightAndSecure:
                                                dataSubjectRightAndSecure.getFieldsValue(),
                                            marketingAdvertising:
                                                marketingAdvertising.getFieldsValue(),
                                            privacyPolicy:
                                                privacyPolicy.getFieldsValue(),
                                            dpo: dpo.getFieldsValue(),
                                            dataController:
                                                dataController.getFieldsValue(),
                                        }}
                                        privacyNoticeId={id}
                                        saveDraft={saveDraft}
                                        dsType={dsType}
                                    />
                                </StepWizard>
                            </div>
                        </Provider>
                    </Spin>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </>
    );
};

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

export default PrivacyDetail;
